<template>
  <ul class="wt-storyboard-category-filter">
    <li
      v-if="allStoryboardCategories.length"
      class="-list-item"
      :class="{
        '-selected': !selectedCategories.length,
      }"
      @click="selectCategory($event, null)"
    >
      <div class="-label">All Topics</div>
    </li>

    <li
      v-if="showUncategorizedItem"
      class="-list-item"
      :class="{ '-selected': selectedCategories.includes(UNCATEGORIZED_FLAG) }"
      @click="selectCategory($event, UNCATEGORIZED_FLAG)"
    >
      <div class="-label">Uncategorized</div>
      <div
        v-if="numberOfUncategorizedTemplates >= 0"
        class="-count"
        v-text="numberOfUncategorizedTemplates"
      />
    </li>

    <li
      v-for="c in allStoryboardCategories"
      :key="c.id"
      class="-list-item"
      :class="{ '-selected': selectedCategories.includes(c.id) }"
      @click="selectCategory($event, c.id)"
    >
      <div class="-label" v-text="c.categoryName" />
      <div
        v-if="c.numberOfTemplates >= 0"
        class="-count"
        v-text="c.numberOfTemplates"
      />
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { UNCATEGORIZED_FLAG } from '#/const.ts';

export default {
  name: 'dashboard-storyboards-categories',

  props: {
    myTemplatesTab: { type: Boolean, default: false },
  },

  data() {
    return { UNCATEGORIZED_FLAG };
  },

  computed: {
    ...mapState([
      'storyboardCategories',
      'channelOwnedCategories',
      'inheritedChannelCategories',
      'numberOfUncategorizedTemplates',
    ]),
    ...mapState({
      selectedCategories: (state) =>
        state.dashboard.storyboardsFilters.categoryIds,
    }),
    ...mapGetters('user', ['isImpededTemplatizer']),

    showUncategorizedItem() {
      return this.myTemplatesTab && this.isImpededTemplatizer;
    },

    allStoryboardCategories() {
      if (this.isImpededTemplatizer) {
        if (this.myTemplatesTab) {
          return this.channelOwnedCategories;
        } else {
          return this.inheritedChannelCategories;
        }
      } else {
        return this.storyboardCategories;
      }
    },
  },

  watch: {
    allStoryboardCategories: {
      handler(_new, _old) {
        if (
          Array.isArray(_new) &&
          Array.isArray(_old) &&
          _new.length !== _old.length
        ) {
          this.$emit('categories-changed');
        }
      },
      deep: true,
    },
  },

  methods: {
    selectCategory(e, id) {
      this.$emit('update-category-id', {
        id,
        multipleSelection: e.metaKey || e.ctrlKey,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt-storyboard-category-filter {
  &::-webkit-scrollbar {
    width: 8px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 0;
  }

  overflow: hidden;
  &:hover {
    overflow: auto;
  }

  padding: 0;
  margin: 0;
  width: 220px;

  .-list-item {
    list-style-type: none;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &.-selected {
      color: $color-primary;
      font-weight: $font-weight-medium;
    }
    &:hover {
      color: $color-blue-d;
    }

    .wticon {
      margin-right: 5px;
    }

    .-label {
      max-width: calc(100% - 30px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .-count {
      margin-right: 10px;
    }
  }
}
</style>
